// src/store/slices/organization/thunks/organization/fetchOrgSeats.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import type { SeatsPayload, SeatSummaryDTO } from '@/types/organization.dtos';
import { mapSeatSummaryDTOToSeats } from '@/store/mappers/organization';

export const fetchOrgSeats = createAdminAsyncThunk<
  SeatsPayload,
  undefined,
  { rejectValue: string }
>(
  'organization/fetchSeats',
  async(_, { extra: { organizationService }, rejectWithValue }) => {
    try {
      const dto: SeatSummaryDTO = await organizationService.getSeatSummary();
      return mapSeatSummaryDTOToSeats(dto);
    } catch (error: unknown) {
      const msg = error instanceof Error ? error.message : 'Failed to load seats data';
      return rejectWithValue(msg);
    }
  }
);
